import clevertap from "clevertap-web-sdk";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

// icons
import { ReactComponent as MinusIcon } from "assets/icons/svg/minus.svg";
import { ReactComponent as PlusIcon } from "assets/icons/svg/add.svg";

// style
import "./style.scss";

const GuestPopUp = ({
	open,
	setOpen,
	typeData,
	infantsData,
	childrenData,
	adultsData,
	roomsData,
	setAdultsData,
	setChildrenData,
	setInfantsData,
	setRoomsData,
	query,
	driverData,
	petData,
	maidData,
	setDriverData,
	setMaidData,
	setPetData,
	showPet,
	petCharge,
	theme = null,
}) => {
	const popRef = useRef();

	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		function handleClickOutside(event) {
			if (popRef.current && !popRef.current.contains(event.target)) {
				setOpen(false);
			}
		}
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [popRef]);

	if (open)
		return (
			<div
				className="guest-popup-wrapper"
				ref={popRef}
				style={{ background: theme?.background }}
			>
				{typeData?.TYPE_FLAG !== "EV" &&
					typeData?.TYPE_FLAG !== "MV" &&
					typeData?.TYPE_FLAG !== "SR" && (
						<div className="guest-elements">
							<span>
								<h3>Rooms</h3>
							</span>

							<div className="guest-counter">
								<button
									aria-label="minus-icon"
									className={
										roomsData === 1 || roomsData === typeData?.MIN_ROOMS
											? "disable"
											: undefined
									}
									disabled={
										roomsData === 1 || roomsData === typeData?.MIN_ROOMS
									}
									onClick={() => {
										if (roomsData > 1) setRoomsData(roomsData - 1);
									}}
								>
									<MinusIcon />
								</button>
								<span className="counter">{roomsData}</span>
								<button
									aria-label="plus-icon"
									className={
										roomsData === typeData?.NUM_SIMILAR_ROOMS && "disable"
									}
									disabled={roomsData === typeData?.NUM_SIMILAR_ROOMS}
									onClick={() => {
										setRoomsData(roomsData + 1);
									}}
								>
									<PlusIcon />
								</button>
							</div>
						</div>
					)}

				{typeData?.TYPE_FLAG === "MV" && (
					<div className="guest-elements">
						<span>
							<h3>Villas</h3>
							<p>{typeData?.NO_OF_BEDROOMS} Bedrooms</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus-icon"
								className={
									(roomsData === 1 || roomsData === typeData?.MIN_ROOMS) &&
									"disable"
								}
								disabled={roomsData === 1 || roomsData === typeData?.MIN_ROOMS}
								onClick={() => {
									if (roomsData > 1) setRoomsData(roomsData - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{roomsData}</span>
							<button
								aria-label="plus-label"
								className={
									roomsData === typeData?.NUM_SIMILAR_ROOMS && "disable"
								}
								disabled={roomsData === typeData?.NUM_SIMILAR_ROOMS}
								onClick={() => {
									setRoomsData(roomsData + 1);
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData?.TYPE_FLAG !== "MV" &&
					typeData?.TYPE_FLAG !== "MR" &&
					typeData?.TYPE_FLAG !== "EV-MR" && (
						<div className="guest-elements">
							<span>
								<h3>Adults</h3>
								<p>12+</p>
							</span>

							<div className="guest-counter">
								<button
									aria-label="minus"
									className={adultsData === typeData?.CAPACITY && "disable"}
									disabled={adultsData === typeData?.CAPACITY}
									onClick={() => {
										if (adultsData > 1) setAdultsData(adultsData - 1);
									}}
								>
									<MinusIcon />
								</button>
								<span className="counter">{adultsData}</span>
								<button
									aria-label="plus"
									className={
										childrenData + adultsData === typeData?.MAX_CAPACITY &&
										"disable"
									}
									disabled={childrenData + adultsData >= typeData?.MAX_CAPACITY}
									onClick={() => {
										if (childrenData + adultsData <= typeData?.MAX_CAPACITY) {
											setAdultsData(adultsData + 1);
										}
									}}
								>
									<PlusIcon />
								</button>
							</div>
						</div>
					)}

				{typeData?.TYPE_FLAG === "EV-MR" && (
					<div className="guest-elements">
						<span>
							<h3>Adults</h3>
							<p>12+ years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={adultsData === typeData?.CAPACITY && "disable"}
								disabled={adultsData === typeData?.CAPACITY}
								onClick={() => {
									if (adultsData > 1) setAdultsData(adultsData - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{adultsData}</span>
							<button
								aria-label="plus"
								className={
									adultsData + childrenData >=
										Math.round(
											typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
										) *
											roomsData && "disable"
								}
								disabled={
									adultsData + childrenData >=
									Math.round(
										typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
									) *
										roomsData
								}
								onClick={() => {
									if (childrenData + adultsData <= typeData?.MAX_CAPACITY) {
										setAdultsData(adultsData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData?.TYPE_FLAG === "MR" && (
					<div className="guest-elements">
						<span>
							<h3>Adults</h3>
							<p>12+ years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={
									adultsData + childrenData === typeData?.CAPACITY && "disable"
								}
								disabled={adultsData + childrenData === typeData?.CAPACITY}
								onClick={() => {
									if (adultsData > 1) setAdultsData(adultsData - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{adultsData}</span>
							<button
								aria-label="plus"
								className={
									!(
										adultsData + childrenData <=
											Math.round(
												typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
											) *
												roomsData &&
										adultsData + childrenData < typeData?.MAX_CAPACITY
									) && "disable"
								}
								disabled={
									!(
										adultsData + childrenData <=
											Math.round(
												typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
											) *
												roomsData &&
										adultsData + childrenData < typeData?.MAX_CAPACITY
									)
								}
								onClick={() => {
									if (childrenData + adultsData < typeData?.MAX_CAPACITY) {
										setAdultsData(adultsData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData?.TYPE_FLAG === "MV" && (
					<div className="guest-elements">
						<span>
							<h3>Adults</h3>
							<p>12+ years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={adultsData === typeData?.CAPACITY && "disable"}
								disabled={adultsData === typeData?.CAPACITY}
								onClick={() => {
									if (adultsData > 1) setAdultsData(adultsData - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{adultsData}</span>
							<button
								aria-label="plus"
								className={
									adultsData + childrenData >=
										(typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS) *
											roomsData && "disable"
								}
								disabled={
									adultsData + childrenData >=
									(typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS) *
										roomsData
								}
								onClick={() => {
									if (childrenData + adultsData <= typeData?.MAX_CAPACITY) {
										setAdultsData(adultsData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData.TYPE_FLAG !== "MR" &&
					typeData.TYPE_FLAG !== "MV" &&
					typeData.TYPE_FLAG !== "EV-MR" && (
						<div className="guest-elements">
							<span>
								<h3>Children</h3>
								<p>6-11 years</p>
							</span>

							<div className="guest-counter">
								<button
									aria-label="minus"
									className={childrenData === 0 && "disable"}
									disabled={childrenData === 0}
									onClick={() => {
										if (childrenData >= 1) setChildrenData(childrenData - 1);
										if (query.get("children") === "1" && childrenData === 1) {
											searchParams.set("children", "");
											setSearchParams(searchParams, { replace: true });
										}
									}}
								>
									<MinusIcon />
								</button>
								<span className="counter">{childrenData}</span>
								<button
									aria-label="plus"
									className={
										adultsData + childrenData >= typeData?.MAX_CAPACITY &&
										"disable"
									}
									disabled={adultsData + childrenData >= typeData?.MAX_CAPACITY}
									onClick={() => {
										if (childrenData + adultsData < typeData?.MAX_CAPACITY) {
											setChildrenData(childrenData + 1);
										}
									}}
								>
									<PlusIcon />
								</button>
							</div>
						</div>
					)}

				{typeData.TYPE_FLAG === "EV-MR" && (
					<div className="guest-elements">
						<span>
							<h3>Children</h3>
							<p>6-11 years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={childrenData === 0 && "disable"}
								disabled={childrenData === 0}
								onClick={() => {
									if (childrenData >= 1) setChildrenData(childrenData - 1);
									if (query.get("children") === "1" && childrenData === 1) {
										searchParams.set("children", "");
										setSearchParams(searchParams, { replace: true });
									}
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{childrenData}</span>
							<button
								aria-label="plus"
								className={
									adultsData + childrenData >=
										Math.round(
											typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
										) *
											roomsData && "disable"
								}
								disabled={
									adultsData + childrenData >=
									Math.round(
										typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
									) *
										roomsData
								}
								onClick={() => {
									if (childrenData + adultsData < typeData?.MAX_CAPACITY) {
										setChildrenData(childrenData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData.TYPE_FLAG === "MV" && (
					<div className="guest-elements">
						<span>
							<h3>Children</h3>
							<p>6-11 years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={childrenData === 0 && "disable"}
								disabled={childrenData === 0}
								onClick={() => {
									if (childrenData >= 1) setChildrenData(childrenData - 1);
									if (query.get("children") === "1" && childrenData === 1) {
										searchParams.set("children", "");
										setSearchParams(searchParams, { replace: true });
									}
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{childrenData}</span>
							<button
								aria-label="plus"
								className={
									adultsData + childrenData >=
										Math.round(
											typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
										) *
											roomsData && "disable"
								}
								disabled={
									adultsData + childrenData >=
									Math.round(
										typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
									) *
										roomsData
								}
								onClick={() => {
									if (childrenData + adultsData < typeData?.MAX_CAPACITY) {
										setChildrenData(childrenData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				{typeData.TYPE_FLAG === "MR" && (
					<div className="guest-elements">
						<span>
							<h3>Children</h3>
							<p>6-11 years</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={childrenData === 0 && "disable"}
								disabled={childrenData === 0}
								onClick={() => {
									if (childrenData >= 1) setChildrenData(childrenData - 1);
									if (query.get("children") === "1" && childrenData === 1) {
										searchParams.set("children", "");
										setSearchParams(searchParams, { replace: true });
									}
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{childrenData}</span>
							<button
								aria-label="plus"
								className={
									!(
										adultsData + childrenData <=
											Math.round(
												typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
											) *
												roomsData &&
										adultsData + childrenData < typeData?.MAX_CAPACITY
									) && "disable"
								}
								disabled={
									!(
										adultsData + childrenData <=
											Math.round(
												typeData?.MAX_CAPACITY / typeData?.NUM_SIMILAR_ROOMS,
											) *
												roomsData &&
										adultsData + childrenData < typeData?.MAX_CAPACITY
									)
								}
								onClick={() => {
									if (childrenData + adultsData < typeData?.MAX_CAPACITY) {
										setChildrenData(childrenData + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}

				<div className="guest-elements">
					<span>
						<h3>Infants</h3>
						<p>0-5 years</p>
					</span>

					<div className="guest-counter">
						<button
							aria-label="minus"
							className={infantsData === 0 && "disable"}
							disabled={infantsData === 0}
							onClick={() => {
								setInfantsData(infantsData - 1);
								if (query.get("infants") === "1" && infantsData === 1) {
									searchParams.set("infants", "");
									setSearchParams(searchParams, { replace: true });
								}
							}}
						>
							<MinusIcon />
						</button>
						<span className="counter">{infantsData}</span>
						<button
							aria-label="plus"
							className={infantsData === 10 && "disable"}
							disabled={infantsData === 10}
							onClick={() => {
								setInfantsData(infantsData + 1);
							}}
						>
							<PlusIcon />
						</button>
					</div>
				</div>
				{maidData > 0 && (
					<div className="guest-elements">
						<span>
							<h3>Maid</h3>
							{/* <p>0-5</p> */}
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={maidData === 0 && "disable"}
								disabled={maidData === 0}
								onClick={() => {
									clevertap.event.push("addMaid_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfMaid: maidData - 1,
										timestamp: new Date(),
									});
									setMaidData((prev) => prev - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{maidData}</span>
							<button
								aria-label="plus"
								className={maidData === 2 && "disable"}
								disabled={maidData === 2}
								onClick={() => {
									if (maidData <= 2) {
										clevertap.event.push("addMaid_btn_booking_page", {
											villaName: typeData?.VILLA_NAME,
											bookingId: typeData?.BOOKING_ID,
											guestId: typeData?.GUEST_ID,
											numberOfMaid: maidData + 1,
											timestamp: new Date(),
										});
										setMaidData((prev) => prev + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}
				{driverData > 0 && (
					<div className="guest-elements">
						<span>
							<h3>Driver</h3>
							{/* <p>0-5</p> */}
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={driverData === 0 && "disable"}
								disabled={driverData === 0}
								onClick={() => {
									clevertap.event.push("addDriver_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfDriver: driverData - 1,
										timestamp: new Date(),
									});
									setDriverData((prev) => prev - 1);
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{driverData}</span>
							<button
								aria-label="plus"
								className={driverData === 2 && "disable"}
								disabled={driverData === 2}
								onClick={() => {
									if (driverData <= 2) {
										clevertap.event.push("addDriver_btn_booking_page", {
											villaName: typeData?.VILLA_NAME,
											bookingId: typeData?.BOOKING_ID,
											guestId: typeData?.GUEST_ID,
											numberOfDriver: driverData + 1,
											timestamp: new Date(),
										});
										setDriverData((prev) => prev + 1);
									}
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}
				{petData > 0 && !showPet && (
					<div className="guest-elements">
						<span>
							<h3>Pet</h3>
							{/* <p>{petCharge}</p> */}
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={petData === 0 && "disable"}
								disabled={petData === 0}
								onClick={() => {
									clevertap.event.push("addPet_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfPet: petData - 1,
										timestamp: new Date(),
									});
									setPetData((prev) => prev - 1);
									if (query.get("infants") === "1" && petData === 1) {
										searchParams.set("infants", "");
										setSearchParams(searchParams, { replace: true });
									}
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{petData}</span>
							<button
								aria-label="plus"
								className={petData === 2 && "disable"}
								disabled={petData === 2}
								onClick={() => {
									clevertap.event.push("addPet_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfPet: petData + 1,
										timestamp: new Date(),
									});
									setPetData((prev) => prev + 1);
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}
				{showPet && (
					<div className="guest-elements">
						<span>
							<h3>Pet</h3>
							<p>₹{petCharge}/pet</p>
						</span>

						<div className="guest-counter">
							<button
								aria-label="minus"
								className={petData === 0 && "disable"}
								disabled={petData === 0}
								onClick={() => {
									clevertap.event.push("addPet_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfPet: petData - 1,
										timestamp: new Date(),
									});
									setPetData((prev) => prev - 1);
									if (query.get("infants") === "1" && petData === 1) {
										searchParams.set("infants", "");
										setSearchParams(searchParams, { replace: true });
									}
								}}
							>
								<MinusIcon />
							</button>
							<span className="counter">{petData}</span>
							<button
								aria-label="plus"
								className={petData === 2 && "disable"}
								disabled={petData === 2}
								onClick={() => {
									clevertap.event.push("addPet_btn_booking_page", {
										villaName: typeData?.VILLA_NAME,
										bookingId: typeData?.BOOKING_ID,
										guestId: typeData?.GUEST_ID,
										numberOfPet: petData + 1,
										timestamp: new Date(),
									});
									setPetData((prev) => prev + 1);
								}}
							>
								<PlusIcon />
							</button>
						</div>
					</div>
				)}
			</div>
		);
	return null;
};

export default GuestPopUp;
